
import React, { useState } from 'react'
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink as RSNavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Container,
} from 'reactstrap'
import { Link, useLocation } from 'react-router-dom'
import './styles/landing.css'

const ORANGE = '#f7931e'

export default function Header() {
  const [open, setOpen] = useState(false)
  const toggle = () => setOpen(v => !v)
  const { pathname } = useLocation()

  const isActive = (href) => pathname === href || pathname.startsWith(href + '/')

  return (
    <header className="cb-header sticky-top bg-white">
      <Navbar expand="lg" light className="py-2 cb-navbar">
        <Container className="align-items-center">

          {/* Logo + text (exact like screenshot) */}
          <NavbarBrand tag={Link} to="/" className="d-flex align-items-center gap-2">
            <img
              src="/logo-coldblock.png"   /* TODO: apni logo path */
              alt="ColdBlock"
              height={38}
              className="me-1"
            />
            <div className="lh-1">
              <div className="fw-semibold fs-5 brand-title">ColdBlock</div>
              <small className="text-muted">Technologies Inc.</small>
            </div>
          </NavbarBrand>

          <NavbarToggler onClick={toggle} className="border-0" />

          <Collapse isOpen={open} navbar>
            {/* LEFT NAV */}
            <Nav navbar className="ms-lg-4 cb-nav">

              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle
                  nav caret
                  className={`cb-link ${isActive('/products') ? 'active' : ''}`}
                >
                  PRODUCTS
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem tag={Link} to="/products">All Products</DropdownItem>
                  <DropdownItem tag={Link} to="/products/series-a">Series A</DropdownItem>
                  <DropdownItem tag={Link} to="/products/series-b">Series B</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>

              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle
                  nav caret
                  className={`cb-link ${isActive('/resources') ? 'active' : ''}`}
                >
                  RESOURCES
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem tag={Link} to="/resources">Application Notes</DropdownItem>
                  <DropdownItem tag={Link} to="/resources/case-studies">Case Studies</DropdownItem>
                  <DropdownItem tag={Link} to="/resources/white-papers">White Papers</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>

              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle
                  nav caret
                  className={`cb-link ${isActive('/about') ? 'active' : ''}`}
                >
                  ABOUT
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem tag={Link} to="/about">About ColdBlock</DropdownItem>
                  <DropdownItem tag={Link} to="/about/team">Executive Team</DropdownItem>
                  <DropdownItem tag={Link} to="/about/board">Board of Directors</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>

              <NavItem>
                <RSNavLink tag={Link} to="/info-hub" className={`cb-link ${isActive('/info-hub') ? 'active' : ''}`}>
                  INFO HUB
                </RSNavLink>
              </NavItem>

              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle
                  nav caret
                  className={`cb-link ${isActive('/media') ? 'active' : ''}`}
                >
                  MEDIA
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem tag={Link} to="/media">Press</DropdownItem>
                  <DropdownItem tag={Link} to="/media/videos">Videos</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>

              <NavItem>
                <RSNavLink tag={Link} to="/sample-submission" className={`cb-link ${isActive('/sample-submission') ? 'active' : ''}`}>
                  SUBMIT SAMPLE
                </RSNavLink>
              </NavItem>

              {/* Search icon exactly like screenshot */}
              <NavItem className="d-flex align-items-center ms-lg-2">
                <button className="cb-icon-btn" aria-label="Search">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
                    <line x1="16.5" y1="16.5" x2="22" y2="22" stroke="currentColor" strokeWidth="2" />
                  </svg>
                </button>
              </NavItem>
            </Nav>

            {/* RIGHT CTA (orange) */}
            <div className="ms-auto d-flex align-items-center my-3 my-lg-0">
              <Button
                tag={Link}
                to="/contact"
                className="fw-semibold px-4 py-2 cb-cta-btn"
                style={{ backgroundColor: ORANGE, borderColor: ORANGE }}
              >
                Contact us
              </Button>
            </div>
          </Collapse>
        </Container>
      </Navbar>

      {/* soft shadow under header */}
      <div className="cb-shadow-line" />
    </header>
  )
}
